import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';
import { Button } from './ui/Button';
import { MORE_LOCATIONS_NOTE } from '../lib/locations';

/**
 * Full-page notice shown on the cart/checkout routes while the store is in
 * retail-only mode (online ordering turned off in Admin → Settings). Checkout
 * is also rejected server-side; this is the friendly storefront face of it.
 */
export function OrderingComingSoon() {
  return (
    <div className="py-20">
      <div className="container-max max-w-xl mx-auto text-center">
        <h1 className="text-3xl font-serif font-bold text-coastal-700 mb-3">Online Ordering Coming Soon</h1>
        <p className="text-gray-700 mb-1">
          We&apos;re not taking online orders just yet. For now, you can find our products at{' '}
          <Link to="/locations" className="font-semibold text-coastal-700 underline hover:text-coastal-900">
            our locations
          </Link>.
        </p>
        <p className="text-gray-700 mb-8">{MORE_LOCATIONS_NOTE}</p>
        <div className="flex flex-wrap justify-center gap-3">
          <Link to="/locations">
            <Button className="inline-flex items-center gap-2">
              <MapPin className="w-4 h-4" /> Where to Find Us
            </Button>
          </Link>
          <Link to="/products">
            <Button variant="outline">View Our Products</Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
